import Axios from "axios"


export async function notice_remove(props) {
    const Set_noticeList = props['Set_noticeList']

    if(window.confirm('삭제하시겠습니까?')) {
        const branch_id = window.EventManager['branchInfo']['id']
        const notice_id = document.getElementById('notice_id').value

        const result = await Axios
                        .post("/notice/remove", {
                            branch_id: branch_id,
                            notice_id: notice_id
                        })

        const data = result['data']
        alert(data['message'])
        if(data['status'] === 'success') {
            Set_noticeList([...data['list']])
        }
    }
}